import React, { useEffect } from "react";
import { Card, Button, Table, Layout, Input, Form, Select, Col } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { communitiesStore, CommunityStatusNames } from "../../store/community/CommunitiesStore";
import { FilterBar } from "../../components/filter/FilterBar";
import { EditCommunityDlg } from "./EditCommunityDlg";
import { Toolbar } from "../../components/Toolbar";
import { Store } from "../../store/Store";

export const Communities = observer(() => {
  const store = communitiesStore;

  const location = useLocation();

  const history = useHistory();

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => (a.state || "").localeCompare(b.state || ""),
    },
    {
      title: "Community Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (t, r) => <Link to={`/communities/${r.id}`}>{t}</Link>,
    },
    {
      title: "Price Pack",
      dataIndex: "pricePack",
      key: "pricePack",
      sorter: (a, b) => a.pricePack?.localeCompare(b.pricePack),
    },
    {
      title: "Carpool Free",
      dataIndex: "carpoolFree",
      key: "carpoolFree",
      render: (t, r) => (t ? "Yes" : "No"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // defaultSortOrder: "ascend" as const,
      sorter: (a, b) => a.status?.localeCompare(b.status),
      render: (t, r) => CommunityStatusNames[t],
    },
    // {
    //   title: "User #",
    //   dataIndex: "userCount",
    //   key: "userCount",
    //   sorter: (a, b) => a.userCount - b.userCount,
    // },
    // {
    //   title: "Division",
    //   dataIndex: ["division", "name"],
    //   key: "division",
    //   sorter: (a, b) => a.division.name.localeCompare(b.division.name),
    // },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   key: "description",
    //   sorter: (a, b) => (a.description || "").localeCompare(b.description || ""),
    // },
    {
      title: "",
      key: "opt",
      render: (_, r) => (Store.isDivision ? null : <EditOutlined onClick={() => store.edit.edit(r.id)} />),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar
        actions={
          Store.isDivision ? null : (
            <Button type="primary" size="large" icon={<PlusOutlined />} onClick={() => store.edit.new()}>
              New Community
            </Button>
          )
        }
      ></Toolbar>

      <FilterBar store={store} actionsSpan={4}>
        <Col span={12}>
          <Form.Item label="Status">
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              placeholder="Please select"
              defaultValue={store.filter.status}
              onChange={(e) => (store.filter.status = e)}
            >
              <Select.Option value="Active">Active</Select.Option>
              <Select.Option value="Visible">Inactive (Users Waiting)</Select.Option>
              <Select.Option value="Inactive">Inactive (No User)</Select.Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item label="Community Name">
            <Input
              value={store.filter.keyword}
              onChange={(e) => (store.filter.keyword = e.target.value)}
              placeholder="Search by name"
            />
          </Form.Item>
        </Col>
      </FilterBar>

      <Card size="small">
        <Table
          size="small"
          rowKey="id"
          columns={columns}
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          dataSource={store.items}
        />
        {store.edit.visible && <EditCommunityDlg onOk={() => {}} />}
      </Card>
    </Layout.Content>
  );
});
